import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, XIcon, CheckCircle2Icon } from 'lucide-react';
const names = ['Martín G.', 'Lucas R.', 'Florencia M.', 'Diego S.', 'Carla P.', 'Sebastián V.', 'Jimena L.', 'Andrés M.', 'Valeria T.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Buenos Aires', 'Santa Fe', 'Tucumán', 'La Plata', 'Mar del Plata'];
const timeAgo = ['hace 2 minutos', 'hace 4 minutos', 'hace 6 minutos', 'hace 8 minutos', 'hace 12 minutos', 'hace 15 minutos'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: ''
  });
  const showNotification = useCallback(() => {
    const index = Math.floor(Math.random() * names.length);
    setData({
      name: names[index],
      city: cities[index],
      time: getRandomItem(timeAgo)
    });
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 5000);
  }, []);
  useEffect(() => {
    // First popup after 5 seconds
    const initialTimer = setTimeout(() => {
      showNotification();
    }, 5000);
    // Then every 3 minutes (180000 ms)
    const interval = setInterval(() => {
      showNotification();
    }, 180000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [showNotification]);
  return <AnimatePresence data-id="element-437">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 max-w-xs" data-id="element-438">
          <div className="bg-card-dark border-l-4 border-l-success rounded-r-xl rounded-l-sm shadow-[0_4px_24px_rgba(0,0,0,0.5)] p-4 flex items-start gap-3 relative" data-id="element-439">
            <button onClick={() => setVisible(false)} className="absolute top-2 right-2 w-5 h-5 flex items-center justify-center text-gray-400 hover:text-white transition-colors" aria-label="Cerrar" data-id="element-440">
              <XIcon className="w-3.5 h-3.5" data-id="element-441" />
            </button>

            <div className="w-10 h-10 rounded-full bg-success/10 flex items-center justify-center shrink-0 mt-1" data-id="element-442">
              <ShoppingBagIcon className="w-5 h-5 text-success" data-id="element-443" />
            </div>

            <div className="pr-4" data-id="element-444">
              <div className="flex items-center gap-1 mb-1" data-id="element-445">
                <CheckCircle2Icon className="w-3 h-3 text-success" data-id="element-446" />
                <span className="text-[10px] font-bold text-success uppercase tracking-wider" data-id="element-447">
                  Compra Verificada
                </span>
              </div>
              <p className="text-sm text-gray-300 leading-tight" data-id="element-448">
                <span className="text-white font-bold" data-id="element-449">{data.name}</span> de{' '}
                {data.city} compró el{' '}
                <span className="text-primary font-semibold" data-id="element-450">Pack Élite</span>
              </p>
              <p className="text-[11px] text-gray-500 mt-1" data-id="element-451">{data.time}</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}